<template>
  <div class="">
    <button
      id="addLabelFilter"
      type="button"
      class="mr-2 d-flex justify-content-between align-items-center"
      :style="{
        color: '#888',
        padding: '3px 5px',
        'border-radius': '3px',
        'font-size': '.9rem',
        border: 'dashed 1px #888',
      }"
    >
      <i class="far fa-plus mr-1 ml-1"></i>
      Add Label
    </button>

    <b-popover target="addLabelFilter" ref="addLabelFilter" triggers="click blur">
      <div class="label mt-1 mb-1 d-flex align-items-center justify-content-center">Add Label</div>
      <hr class="mt-2 mb-2" />
      <input type="text" v-model="filter" class="form-control mb-2 mt-1" placeholder="Filter..." />

      <div class="bi-label-container">
        <div v-for="label in filteredLabels" :key="label.id">
          <div
            class="bi-label mb-2 cursor-pointer"
            :style="{
              'background-color': label.color,
            }"
            @click="addLabel(label)"
          >
            <i v-if="label.icon" :class="label.icon" class="mr-1 ml-1"></i>
            {{ label.title }}
          </div>
        </div>

        <div v-if="!filteredLabels.length">
          <div class="bi-label no-available-labels mb-2">No labels available</div>
        </div>
      </div>
    </b-popover>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import { LabelModule, LabelStore } from '@/store/label';

  @Component
  export default class AddLabelsFilter extends Vue {
    private labelStore: LabelModule = LabelStore;

    private filter = '';

    async mounted() {
      await this.labelStore.getAllLabelsAsync(this.boardId);
    }

    get filteredLabels() {
      return this.labels.filter((item) => item.title.toLowerCase().indexOf(this.filter.toLowerCase()) >= 0);
    }

    async addLabel(label) {
      this.$emit('labeladded', label);
      this.$root.$emit('bv::hide::popover');
    }

    get labels() {
      return this.labelStore.allActiveSelectedLabels;
    }

    get boardId() {
      return this.$route.params.id;
    }
  }
</script>

<style scoped lang="scss">
  .label {
    font-weight: bold;
    font-size: 1rem;
  }

  .bi-label-container {
    max-height: 200px;
    overflow-y: auto;
  }

  .bi-label-container::-webkit-scrollbar {
    width: 8px;
  }

  .bi-label-container::-webkit-scrollbar-track {
    background: #ddd;
    border-radius: 5px;
  }

  .bi-label-container::-webkit-scrollbar-thumb {
    background: #999;
    border: 2px solid #ddd;
    border-radius: 5px;
  }

  .bi-label {
    color: white;
    padding: 3px 5px;
    border-radius: 3px;
    margin-right: 5px;
  }

  .bi-label,
  no-available-labels {
    background-color: #4e667d;
  }
</style>
